import { c as _c } from "react-compiler-runtime";
import React, { useRef, useEffect, useLayoutEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TextStyled } from '@nike/nike-design-system-components';
import { useModal } from '@nike/podium-dialog-manager';
import tokens from '@nike/design-system-base';
import { ConfirmationBackdropStyled, ConfirmationModalStyled, GreenCheckCircleFilled, ModalHeaderWrapper } from './styles';
import ProductAddedModalProductCard from './ProductAddedModalProductCard';
import { ItemAddedModalProvider } from './ItemAddedModalContext';
import releaseScrollLock from "../../../utils/release-scroll-lock";
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";
var DESKTOP_MIN_WIDTH_PX = tokens.bp('desktop');
var scrollPageToTop = function scrollPageToTop() {
  if (typeof window === 'undefined') {
    return;
  }
  var scrollingElement = document.scrollingElement || document.documentElement;
  if (scrollingElement) {
    scrollingElement.scrollTop = 0;
  }
  document.body.scrollTop = 0;
  window.scrollTo(0, 0);
};
var ModalHeader = function ModalHeader(t0) {
  var $ = _c(3);
  var title = t0.title;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/React.createElement(GreenCheckCircleFilled, {
      size: "s"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var t2;
  if ($[1] !== title) {
    t2 = /*#__PURE__*/React.createElement(ModalHeaderWrapper, null, t1, /*#__PURE__*/React.createElement(TextStyled, {
      appearance: "body1Strong",
      Component: "h2"
    }, title));
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
ModalHeader.propTypes = {
  title: PropTypes.string
};
var ProductAddedModal = function ProductAddedModal(t0) {
  var $ = _c(37);
  var title = t0.title,
    ActionsSlot = t0.ActionsSlot,
    ProductSizeComponent = t0.ProductSizeComponent,
    PriceComponent = t0.PriceComponent,
    t1 = t0.shouldScrollToTopOnOpen,
    t2 = t0.isMiniBagSubtotalVariant;
  var shouldScrollToTopOnOpen = t1 === undefined ? false : t1;
  var isMiniBagSubtotalVariant = t2 === undefined ? false : t2;
  var _useModal = useModal(true),
    isOpen = _useModal.isOpen,
    closeModal = _useModal.closeModal,
    openModal = _useModal.openModal;
  var _useItemAddedModalSto = useItemAddedModalStore(_temp),
    itemId_0 = _useItemAddedModalSto.itemId,
    productId_0 = _useItemAddedModalSto.productId,
    productCode_0 = _useItemAddedModalSto.productCode,
    closeStoreModal = _useItemAddedModalSto.closeModal;
  var t3;
  if ($[0] !== closeModal || $[1] !== closeStoreModal) {
    t3 = function t3() {
      releaseScrollLock();
      closeModal();
      closeStoreModal();
    };
    $[0] = closeModal;
    $[1] = closeStoreModal;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  var handleCloseModal = t3;
  var t4;
  if ($[3] !== PriceComponent || $[4] !== ProductSizeComponent || $[5] !== handleCloseModal || $[6] !== isMiniBagSubtotalVariant) {
    t4 = {
      ProductSizeComponent: ProductSizeComponent,
      PriceComponent: PriceComponent,
      handleCloseModal: handleCloseModal,
      isMiniBagSubtotalVariant: isMiniBagSubtotalVariant
    };
    $[3] = PriceComponent;
    $[4] = ProductSizeComponent;
    $[5] = handleCloseModal;
    $[6] = isMiniBagSubtotalVariant;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  var contextValue = t4;
  var t5;
  if ($[8] === Symbol["for"]("react.memo_cache_sentinel")) {
    t5 = [];
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(_temp3, t5);
  var t6;
  var t7;
  if ($[9] !== isOpen || $[10] !== itemId_0 || $[11] !== openModal || $[12] !== productCode_0 || $[13] !== productId_0 || $[14] !== shouldScrollToTopOnOpen) {
    t6 = function t6() {
      if (!isOpen && Boolean(itemId_0 && (productId_0 || productCode_0))) {
        if (shouldScrollToTopOnOpen && typeof window !== "undefined" && window.innerWidth >= DESKTOP_MIN_WIDTH_PX) {
          scrollPageToTop();
        }
        openModal();
      }
    };
    t7 = [isOpen, itemId_0, productId_0, productCode_0, openModal, shouldScrollToTopOnOpen];
    $[9] = isOpen;
    $[10] = itemId_0;
    $[11] = openModal;
    $[12] = productCode_0;
    $[13] = productId_0;
    $[14] = shouldScrollToTopOnOpen;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  useEffect(t6, t7);
  var modalContainer = useRef(null);
  var t8;
  var t9;
  if ($[17] !== handleCloseModal || $[18] !== isOpen) {
    t8 = function t8() {
      var modalContainerRef = modalContainer === null || modalContainer === void 0 ? void 0 : modalContainer.current;
      if (modalContainerRef) {
        if (isOpen) {
          modalContainerRef.addEventListener("animationend", handleCloseModal);
        } else {
          modalContainerRef.removeEventListener("animationend", handleCloseModal);
        }
      }
      return function () {
        if (modalContainerRef) {
          modalContainerRef.removeEventListener("animationend", handleCloseModal);
        }
      };
    };
    t9 = [isOpen, handleCloseModal];
    $[17] = handleCloseModal;
    $[18] = isOpen;
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  useLayoutEffect(t8, t9);
  var t10;
  var t11;
  if ($[21] === Symbol["for"]("react.memo_cache_sentinel")) {
    t10 = {
      "data-automation": "product-added-modal-container"
    };
    t11 = {
      backdropContainer: "confirmation--modalcontainer",
      base: "confirmation-modalbase fade-out",
      content: "confirmation--modalcontent modal-content-container"
    };
    $[21] = t10;
    $[22] = t11;
  } else {
    t10 = $[21];
    t11 = $[22];
  }
  var t12;
  if ($[23] !== title) {
    t12 = {
      BackdropComp: ConfirmationBackdropStyled,
      ModalHeaderComp: function ModalHeaderComp() {
        return /*#__PURE__*/React.createElement(ModalHeader, {
          title: title
        });
      }
    };
    $[23] = title;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  var t13;
  if ($[25] !== ActionsSlot) {
    t13 = {
      FooterSlot: ActionsSlot
    };
    $[25] = ActionsSlot;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  var t14;
  if ($[27] === Symbol["for"]("react.memo_cache_sentinel")) {
    t14 = /*#__PURE__*/React.createElement(ProductAddedModalProductCard, null);
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  var t15;
  if ($[28] !== handleCloseModal || $[29] !== isOpen || $[30] !== t12 || $[31] !== t13 || $[32] !== title) {
    t15 = /*#__PURE__*/React.createElement(ConfirmationModalStyled, {
      ref: modalContainer,
      isOpen: isOpen,
      closeModal: handleCloseModal,
      title: title,
      role: "dialog",
      "aria-modal": "true",
      modalRootCompProps: t10,
      classes: t11,
      components: t12,
      shouldCloseOnBackgroundClick: true,
      shouldCloseOnEsc: true,
      slots: t13
    }, t14);
    $[28] = handleCloseModal;
    $[29] = isOpen;
    $[30] = t12;
    $[31] = t13;
    $[32] = title;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  var t16;
  if ($[34] !== contextValue || $[35] !== t15) {
    t16 = /*#__PURE__*/React.createElement(ItemAddedModalProvider, {
      value: contextValue
    }, t15);
    $[34] = contextValue;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};
ProductAddedModal.propTypes = {
  title: PropTypes.string.isRequired,
  ActionsSlot: PropTypes.node.isRequired,
  ProductSizeComponent: PropTypes.elementType.isRequired,
  PriceComponent: PropTypes.elementType.isRequired,
  shouldScrollToTopOnOpen: PropTypes.bool,
  isMiniBagSubtotalVariant: PropTypes.bool
};
export default ProductAddedModal;
function _temp(t0) {
  var itemId = t0.itemId,
    productId = t0.productId,
    productCode = t0.productCode,
    closeModal_0 = t0.closeModal;
  return {
    itemId: itemId,
    productId: productId,
    productCode: productCode,
    closeModal: closeModal_0
  };
}
function _temp2() {
  return releaseScrollLock();
}
function _temp3() {
  return _temp2;
}